import amapi from '@/api/amapi'

const initialState = () => ({})

const state = initialState

const getters = {}

const mutations = {}

const actions = {
  async getUpgradesData ({ dispatch }, hostingId) {
    try {
      const { upgradedata } = await amapi.makecall('upgrades', { id: hostingId })

      return upgradedata
    } catch (e) {
      throw e
    }
  },
  async submitRequest ({ dispatch }, data) {
    try {
      return amapi.makecall('updowngrade_request', data)
    } catch (e) {
      throw e
    }
  },
  async viewRequest ({ dispatch }, id) {
    try {
      return amapi.makecall('updowngrade_view', id)
    } catch (e) {
      throw e
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
